<template>
	<section class="section">
		<form v-if="!loaded" id="import" class="container">
			<div class="field">
				<label class="label" for="source">Source:</label>
				<input class="input" v-model="source" name="source" type="text" placeholder="" />
				<label class="checkbox">
					<input type="checkbox" v-model="forceExtraction">
					Force Extraction
				</label>
			</div>
			<div class="columns is-mobile">
				<div class="column">
					<a class="button is-success is-outlined" 
						v-bind:class="{ 'is-loading': loading }"
						v-on:click="doimport">Import</a>
				</div>
				<div class="column has-text-right">
					<a class="button is-dark is-outlined" v-on:click="cancel">Cancel</a>
				</div>
			</div>
		</form>
		<form v-if="loaded" id="import" class="container">
			<div class="field">
				<label class="label" for="name">Name:</label>
				<input class="input" v-model="recipe.name" name="name" type="text" placeholder="" />
			</div>
			<div class="field">
				<label class="label" for="category">Category:</label>
				<input class="input" v-model="recipe.category" name="category" type="text" placeholder="Category" />
			</div>
			<div class="field">
				<label class="label" for="category">Tags:</label>
				<input class="input" v-model="recipe.tags" name="tags" type="text" placeholder="Comma separated tags" />
			</div>
			<div class="field">
				<label class="label" for="servings">Servings:</label>
				<input class="input" v-model.number="recipe.servings" name="servings" type="number" placeholder="Servings" />
			</div>
			<div class="field">
				<label class="label" for="preptime">Prep time (minutes):</label>
				<input class="input" v-model.number="recipe.preptime" number name="preptime" type="text" placeholder="Prep time" />
			</div>
			<div class="field">
				<label class="label" for="cooktime">Cooking Time (minutes):</label>
				<input class="input" v-model.number="recipe.cooktime" number name="cooktime" type="text" placeholder="Cooking time" />
			</div>
			<div class="field">
				<label class="label" for="source">Source:</label>
				<input class="input" v-model="recipe.source" name="source" type="text" placeholder="Source" />
			</div>
			<div class="field">
				<label class="label" for="ingredients">Ingredients:</label>
				<textarea class="textarea" v-model="recipe.ingredients" name="ingredients"></textarea>
			</div>
			<div class="field">
				<label class="label" for="instructions">Instructions:</label>
				<div class="control">
					<textarea class="textarea" v-model="recipe.instructions" name="instructions"></textarea>
				</div>
			</div>
			<div class="field">
				<label class="label" for="notes">Notes:</label>
				<textarea class="textarea" v-model="recipe.notes" name="notes"></textarea>
			</div>
			<div class="columns is-mobile">
				<div class="column">
					<a class="button is-success is-outlined" v-on:click="save">Save</a>
				</div>
				<div class="column has-text-right">
					<a class="button is-dark is-outlined" v-on:click="cancel">Cancel</a>
				</div>
			</div>
			<pre v-if="false">{{ $data }}</pre>
		</form>
	</section>
</template>

<script>
	import {db} from '@/variables.js'

	export default {
		data: function () {
			return {
				source: '',
				loading: false,
				loaded: false,
				forceExtraction: false,
				response: {},
				recipe: {}
			}
		},
		methods: {
			doimport: function() {
				var vm = this

				var url = new URL("https://api.spoonacular.com/recipes/extract")
				url.searchParams.append("url", vm.source)
				url.searchParams.append("forceExtraction", vm.forceExtraction)
				url.searchParams.append("apiKey", "807bbdda35b3438084f20ee99390d9b4")

				vm.loading = true

				fetch(url).then( function( response ) {
					console.log(response)
					vm.ingested = true
					//vm.response = response
					return response.json()
				}).then( function( data ) {
					vm.loading = false
					vm.loaded = true

					vm.response = data

					vm.recipe.name = data.title
					vm.recipe.servings = data.servings
					vm.recipe.preptime = data.preparationMinutes
					vm.recipe.cooktime = data.cookingMinutes

					if( data.creditsText )
					{
						vm.recipe.source = data.creditsText + " " + data.sourceUrl
					}
					else
					{
						vm.recipe.source = data.sourceUrl
					}

					var ingredients = data.extendedIngredients.length
					vm.recipe.ingredients = new Array( ingredients )
					for( var i = 0; i < ingredients; i++ )
					{
						vm.recipe.ingredients[i] = data.extendedIngredients[i].originalString
					}
					vm.recipe.ingredients = vm.recipe.ingredients.join('\n')

					var steps = data.analyzedInstructions[0].steps.length
					vm.recipe.instructions = new Array( steps )
					for( var j = 0; j < steps; j++ )
					{
						vm.recipe.instructions[j] = data.analyzedInstructions[0].steps[j].step
					}
					vm.recipe.instructions = vm.recipe.instructions.join('\n')

				}).catch( function( error ) {
					vm.loading = false
					vm.loaded = false
					alert( error )
				})
			},
			save: function() {
				var vm = this

				if (this.recipe.name)
				{
					this.recipe.name = this.recipe.name.trim()
				}

				if (this.recipe.category)
				{
					this.recipe.category = this.recipe.category.trim()
				}

				if( this.recipe.tags )
				{
					this.recipe.tags = this.recipe.tags.split(',')
					for( var idx in this.recipe.tags )
					{
						this.recipe.tags[idx] = this.recipe.tags[idx].trim()
					}
					this.recipe.tags.sort()
				}

				if (this.recipe.ingredients)
				{
					this.recipe.ingredients = this.recipe.ingredients.split('\n')
				}

				if (this.recipe.instructions)
				{
					this.recipe.instructions = this.recipe.instructions.split('\n')
				}

				var now = new Date()
				this.recipe.created_at = now.toJSON()

				db.post(this.recipe).then(function(response){
					console.log(response)
					vm.$router.push('recipe/' + response.id)
				}).catch(function(error){
					alert(error.message)
					console.log(error)
				})
			},
			cancel: function() {
				if (!this.loaded || window.confirm("Press OK to discard any changes to this recipe"))
				{
					this.$router.go(-1)	
				}
			}
		}
	}
</script>
